module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container",
    attrs: {
      "id": "ql-forgot-screen"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require('../assets/img/cuelistBLACK.png'),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [(!_vm.sent) ? _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('p', [_vm._v("Please enter your email address to request a password reset.")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "forgot-wrapper"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("RESET PASSWORD")]), _vm._v(" "), _c('md-button', {
    staticClass: "btn-troubleshoot",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back to Login")])], 1)], 1)]) : _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-offset": "35",
      "md-align": "center"
    }
  }, [_c('p', [_vm._v("We just sent you and email to reset your password! Redirecting...")])])], 1)], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e57349d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/forgot.vue
// module id = 655
// module chunks = 2